import api from './api';

export const modelService = {
  // Upload a tweaked InSync Excel model for an asset; the Variance widget then
  // ingests it (Model Inputs vs consensus).
  upload: async (ticker: string, file: File): Promise<{ ticker: string; filename: string }> => {
    const form = new FormData();
    form.append('ticker', ticker);
    form.append('file', file);
    const res = await api.post('/models/upload', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },
};
